import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import * as TableUI from '../../../../../components/Table/Table'

export const RowHead = memo(() => {
  const {t} = useTranslation()

  return (
    <TableUI.THead>
      <tr>
        <th>{t('No')}</th>
        <th>{t('Sales Org Code')}</th>
        <th>Sales Org</th>
        <th>{t('Customer Code')}</th>
        <th>{t('Customer Name')}</th>
        <th>{t('Product Code')}</th>
        <th>{t('kontrak-nama')}</th>
        <th>{t('Region Name')}</th>
        <th>{t('City Name')}</th>
        <th>Minimum {t('Harga')}</th>
        <th>{t('Selling Price')}</th>
        <th>{t('Discount')}</th>
        <th>{t('Purchase Price')}</th>
        <th>{t('deskrisi')}</th>
        <th>Status</th>
        <th>{t('order-aksi')}</th>
      </tr>
    </TableUI.THead>
  )
})
